import { useState } from "react";
import { Box, Tab, Tabs } from "@mui/material";
import SentCampaignsLog from "./SentCampaignsLog";
import SentUniversityCoursesLog from "./SentUniversityCoursesLog";
import CourseAuditLog from "./CourseAuditLog";
import SimAuditLog from "./SimAuditLog";
import AdminLogsTable from "../users/AdminLogsTable";

const TabPanel = ({ children, value, index }) => (
    <div role="tabpanel" hidden={value !== index}>
        {value === index && <Box sx={{ pt: 2 }}>{children}</Box>}
    </div>
);

const Logs = () => {
    const [topTab, setTopTab] = useState(0);
    const [activityTab, setActivityTab] = useState(0);
    const [emailsTab, setEmailsTab] = useState(0);
    const [usersTab, setUsersTab] = useState(0);

    return (
        <Box sx={{ p: 3 }}>
            <Tabs
                value={topTab}
                onChange={(e, newVal) => setTopTab(newVal)}
            >
                <Tab label="Emails" />
                <Tab label="Activity" />
                <Tab label="Users" />
            </Tabs>

            <TabPanel value={topTab} index={0}>
                <Tabs
                    value={emailsTab}
                    onChange={(e, newVal) => setEmailsTab(newVal)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Simulation Audit Logs" />
                    <Tab label="Course Audit Logs" />
                </Tabs>
                <TabPanel value={emailsTab} index={0}><SimAuditLog /></TabPanel>
                <TabPanel value={emailsTab} index={1}><CourseAuditLog /></TabPanel>
            </TabPanel>

            <TabPanel value={topTab} index={1}>
                <Tabs
                    value={activityTab}
                    onChange={(e, newVal) => setActivityTab(newVal)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="Sent Campaigns" />
                    <Tab label="Sent University Courses" />
                    <Tab label="Sent Reminders History" />
                </Tabs>
                <TabPanel value={activityTab} index={0}><SentCampaignsLog /></TabPanel>
                <TabPanel value={activityTab} index={1}><SentUniversityCoursesLog /></TabPanel>
                <TabPanel value={activityTab} index={2}><AdminLogsTable tab="SendReminder" /></TabPanel>
            </TabPanel>

            <TabPanel value={topTab} index={2}>
                <Tabs
                    value={usersTab}
                    onChange={(e, newVal) => setUsersTab(newVal)}
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={{ borderBottom: 1, borderColor: 'divider' }}
                >
                    <Tab label="User Sync" />
                    <Tab label="User Activity" />
                </Tabs>
                <TabPanel value={usersTab} index={0}><AdminLogsTable tab="UserCreation" /></TabPanel>
                <TabPanel value={usersTab} index={1}><AdminLogsTable tab="UserManagement" /></TabPanel>
            </TabPanel>
        </Box>
    );
};

export default Logs;
